export default __webpack_public_path__ + "static/media/SearchIcon.cd79c22b.svg";